import axios from '@/plugins/axios';
import { REBATE_CODE, BONUS_POP_CODE } from '@/core/constants/bonusMap.js';
export default {
  namespaced: true,

  state: {
    cashRegister: [],
    loadingCashRegister: true,
    rebate: {},
    bonusPOP: {},
    rebateDetail: [],
    hasError: '',
  },

  getters: {
    cashRegister: (state) => state.cashRegister,
    loadingCashRegister: (state) => state.loadingCashRegister,
    rebate: (state) => state.rebate,
    rebateDetail: (state) => state.rebateDetail,
    rebateDetailError: (state) => state.hasError,
  },

  mutations: {
    SET_CASH_REGISTER(state, data) {
      state.cashRegister = data;
    },
    SET_LOADING(state, data) {
      state.loadingCashRegister = data;
    },
    SET_REBATE(state, data) {
      state.rebate = data;
    },
    SET_BONUS_POP(state, data) {
      state.bonusPOP = data;
    },
    SET_REBETE_DETAIL(state, data) {
      state.rebateDetail = data;
    },
    SET_ERROR(state, message) {
      state.hasError = message;
    },
  },

  actions: {
    async getBonusesCustomer({ dispatch, commit }, { customerCode, channel }) {
      try {
        const response = await axios.post('/cover/bonus/cash-register', {
          customerCode,
          channel,
        });

        commit('SET_CASH_REGISTER', response.data);
        await dispatch('setBonusesByCode');
      } catch (error) {
        throw new Error('Ocurrió un error al consultar los bonos');
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async setBonusesByCode({ dispatch, commit }) {
      commit('SET_REBATE', await dispatch('searchBonusByCode', REBATE_CODE));
      commit(
        'SET_BONUS_POP',
        await dispatch('searchBonusByCode', BONUS_POP_CODE)
      );
    },

    searchBonusByCode({ state }, code) {
      const rebateFound = state.cashRegister.find(
        (item) => item.CODIGO === code
      );
      if (rebateFound) {
        return {
          amount: rebateFound.MONTO,
          available: rebateFound.DISPO,
        };
      }
      return { amount: 0, available: 0 };
    },
    async setRebateDetail({ commit }, { customer, quarter, year }) {
      try {
        const response = await axios.post('/get-rebate-detail', {
          customer,
          quarter,
          year,
        });
        commit('SET_REBETE_DETAIL', response.data);
      } catch (error) {
        commit(
          'SET_ERROR',
          'Ocurrió un error al consultar el detalle de bono rebate'
        );
      }
    },
    async getExcelFile(_, payload) {
      try {
        const file = await axios.post(
          '/rebate-detail/export',
          {
            selectedItems: payload.selectedItems,
            customer: payload.customer,
          },
          {
            responseType: 'blob',
          }
        );
        return { ok: true, file };
      } catch (error) {
        return { ok: false, message: 'Sucedió un error al generar el archivo' };
      }
    },

    async getPopResume(_, payload) {
      const response = await axios.get('bonus/customer/pop-resume', {
        params: {
          user: payload.customer,
          channel: payload.channel,
        },
      });
      return response.data;
    },
  },
};
